export function CtaBanner() {
  return (
    <section
      style={{ padding: '0 24px 80px', maxWidth: '1200px', margin: '0 auto' }}
    >
      <div
        style={{
          background:
            'linear-gradient(135deg, #3B82F6 0%, #6366F1 50%, #8B5CF6 100%)',
          borderRadius: '28px',
          padding: 'clamp(48px, 6vw, 80px) clamp(32px, 6vw, 80px)',
          textAlign: 'center',
          position: 'relative',
          overflow: 'hidden',
          boxShadow: '0 24px 64px rgba(99,102,241,0.3)',
        }}
      >
        {/* Decorative blobs */}
        <div
          style={{
            position: 'absolute',
            top: '-80px',
            left: '-80px',
            width: '280px',
            height: '280px',
            borderRadius: '50%',
            background: 'rgba(255,255,255,0.08)',
            filter: 'blur(30px)',
            pointerEvents: 'none',
          }}
        />
        <div
          style={{
            position: 'absolute',
            bottom: '-80px',
            right: '-60px',
            width: '320px',
            height: '320px',
            borderRadius: '50%',
            background: 'rgba(255,255,255,0.06)',
            filter: 'blur(40px)',
            pointerEvents: 'none',
          }}
        />

        {/* Dot grid overlay */}
        <div
          style={{
            position: 'absolute',
            inset: 0,
            backgroundImage:
              'radial-gradient(circle, rgba(255,255,255,0.15) 1px, transparent 1px)',
            backgroundSize: '28px 28px',
            borderRadius: '28px',
            pointerEvents: 'none',
          }}
        />

        <div style={{ position: 'relative', zIndex: 1 }}>
          <div
            style={{
              display: 'inline-flex',
              alignItems: 'center',
              gap: '8px',
              background: 'rgba(255,255,255,0.18)',
              border: '1px solid rgba(255,255,255,0.3)',
              borderRadius: '100px',
              padding: '6px 16px',
              marginBottom: '24px',
              backdropFilter: 'blur(8px)',
            }}
          >
            <span
              style={{
                fontSize: '12px',
                letterSpacing: '0.5px',
                color: 'white',
                fontWeight: '600',
              }}
            >
              🚀 Join 500K+ users
            </span>
          </div>

          <h2
            style={{
              fontSize: 'clamp(28px, 4vw, 54px)',
              fontWeight: '900',
              letterSpacing: '-1.5px',
              color: 'white',
              margin: '0 0 16px',
              lineHeight: '1.1',
            }}
          >
            Start getting verified
            <br />
            <span style={{ opacity: 0.85 }}>in seconds, for free.</span>
          </h2>

          <p
            style={{
              fontSize: '18px',
              color: 'rgba(255,255,255,0.8)',
              maxWidth: '480px',
              margin: '0 auto 40px',
              lineHeight: '1.6',
            }}
          >
            No credit card required. No setup. Your first virtual number is on
            us.
          </p>

          <div
            style={{
              display: 'flex',
              justifyContent: 'center',
              gap: '16px',
              flexWrap: 'wrap',
            }}
          >
            <a
              href="#country-pricing"
              style={{
                display: 'inline-flex',
                alignItems: 'center',
                gap: '8px',
                background: 'white',
                color: '#4F46E5',
                textDecoration: 'none',
                fontSize: '16px',
                fontWeight: '700',
                padding: '16px 36px',
                borderRadius: '12px',
                transition: 'all 0.25s ease',
                boxShadow: '0 8px 24px rgba(0,0,0,0.15)',
              }}
              onMouseEnter={(e) => {
                e.currentTarget.style.transform = 'translateY(-2px)'
                e.currentTarget.style.boxShadow = '0 16px 36px rgba(0,0,0,0.2)'
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.transform = 'translateY(0)'
                e.currentTarget.style.boxShadow = '0 8px 24px rgba(0,0,0,0.15)'
              }}
            >
              Get Free Number
              <svg
                width="18"
                height="18"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth="2.5"
              >
                <path d="M5 12h14M12 5l7 7-7 7" />
              </svg>
            </a>
            <a
              href="#how-it-works"
              style={{
                display: 'inline-flex',
                alignItems: 'center',
                gap: '8px',
                background: 'rgba(255,255,255,0.15)',
                border: '1.5px solid rgba(255,255,255,0.35)',
                color: 'white',
                textDecoration: 'none',
                fontSize: '16px',
                fontWeight: '600',
                padding: '16px 32px',
                borderRadius: '12px',
                transition: 'all 0.25s ease',
                backdropFilter: 'blur(8px)',
              }}
              onMouseEnter={(e) => {
                e.currentTarget.style.background = 'rgba(255,255,255,0.25)'
                e.currentTarget.style.transform = 'translateY(-1px)'
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.background = 'rgba(255,255,255,0.15)'
                e.currentTarget.style.transform = 'translateY(0)'
              }}
            >
              Learn More
            </a>
          </div>
        </div>
      </div>
    </section>
  )
}
